import { render } from "./CommodityList.vue?vue&type=template&id=3ee59b5a&scoped=true"
import script from "./CommodityList.vue?vue&type=script&lang=js"
export * from "./CommodityList.vue?vue&type=script&lang=js"

import "./CommodityList.vue?vue&type=style&index=0&id=3ee59b5a&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee59b5a"]])

export default __exports__